import { render, staticRenderFns } from "./AddOrder.vue?vue&type=template&id=0a6f2d26"
import script from "./AddOrder.vue?vue&type=script&lang=js"
export * from "./AddOrder.vue?vue&type=script&lang=js"
import style0 from "./AddOrder.vue?vue&type=style&index=0&id=0a6f2d26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports